import { type PropsWithChildren } from 'react';
import '../styles.scss';

export function NotificationLayout({ children }: PropsWithChildren) {
  return <div className="notification-layout">{children}</div>;
}

export default NotificationLayout;
